import { render, staticRenderFns } from "./rfm-analyse.vue?vue&type=template&id=dd6c8db8&scoped=true&"
import script from "./rfm-analyse.vue?vue&type=script&lang=js&"
export * from "./rfm-analyse.vue?vue&type=script&lang=js&"
import style0 from "./rfm-analyse.vue?vue&type=style&index=0&id=dd6c8db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6c8db8",
  null
  
)

export default component.exports